<template>
    <div>
        <div>
            <div class="card p-2">
                <div class="text-center p-4 mb-4 bg-dark">
                    <span class="h1 font-weight-bold">
                        <i class="fa-solid fa-list-check mr-3"></i>
                        AUTORIZACIONES
                    </span>
                    <p class="mt-2">Registrar una nueva autorización preventivo para la Super Transporte.</p>
                </div>
                <div class="bg-dark p-3">
                    <form v-on:submit.prevent="guardarAutorizacion">
                        <PasoAPaso numero="1" descripcion="Paso 1, Diligenciar información de la autorización"
                            class="w-100 mt-4">
                            <div class="row mt-4 align-items-start">
                                <!-- Fecha -->
                                <div class="col-xl-6 mb-3">
                                    <label for="fechaViaje" class="form-label">Fecha Viaje</label>
                                    <input v-model="formData.fechaViaje" type="date" id="fechaViaje"
                                        class="form-control" required />
                                </div>

                                <!-- Punto de Origen Centros Poblados -->
                                <div class="col-xl-6 mb-3">
                                    <label for="origen" class="form-label">Punto de |Origen</label>
                                    <select v-model="formData.origen" id="origen" class="form-control" required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="centro in CentrosPoblados" :key="centro.codigo"
                                            :value="centro.codigo">
                                            {{ centro.descripcion }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Punto de Destino Centros Poblados -->
                                <div class="col-xl-6 mb-3">
                                    <label for="destino" class="form-label">Punto de Destino</label>
                                    <select v-model="formData.destino" id="destino" class="form-control" required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="centro in CentrosPoblados" :key="centro.codigo"
                                            :value="centro.codigo">
                                            {{ centro.descripcion }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Tipo de Identificación NNa -->
                                <div class="col-xl-6 mb-3">
                                    <label for="tipoIdentificacionNna" class="form-label">Tipo de Identificación
                                        NNa</label>
                                    <select v-model="formData.tipoIdentificacionNna" id="tipoIdentificacionNna"
                                        class="form-control" required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="tipo in tipoIdentificaciones" :key="tipo.codigo"
                                            :value="tipo.codigo">
                                            {{ tipo.descripcion }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Número de Identificación NNa -->
                                <div class="col-xl-6 mb-3">
                                    <label for="numeroIdentificacionNna" class="form-label">Número de Identificación
                                        NNa</label>
                                    <input v-model="formData.numeroIdentificacionNna" type="number"
                                        id="numeroIdentificacionNna" class="form-control" required />
                                </div>

                                <!-- Nombres y Apellidos NNa -->
                                <div class="col-xl-6 mb-3">
                                    <label for="nombresApellidosNna" class="form-label">Nombres y Apellidos Nna</label>
                                    <input v-model="formData.nombresApellidosNna" type="text" id="nombresApellidosNna"
                                        class="form-control" required />
                                </div>

                                <!-- Situación Discapacidad -->
                                <div class="col-xl-6 mb-3">
                                    <label for="situacionDiscapacidad" class="form-label">Situación Discapacidad</label>
                                    <select v-model="formData.situacionDiscapacidad" id="situacionDiscapacidad"
                                        class="form-control" required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option value="SI">SI</option>
                                        <option value="NO">NO</option>
                                    </select>
                                </div>

                                <!-- Tipo de Discapacidades -->
                                <div class="col-xl-6 mb-3" v-if="formData.situacionDiscapacidad === 'SI'">
                                    <label for="tipoDiscapacidad" class="form-label">Tipo de Discapacidades</label>
                                    <select v-model="formData.tipoDiscapacidad" id="tipoDiscapacidad"
                                        class="form-control" required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="tipo in tipoDiscapacidades" :key="tipo.codigo"
                                            :value="tipo.codigo">
                                            {{ tipo.descripcion }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Pertenece Comunidad Étnica -->
                                <div class="col-xl-6 mb-3">
                                    <label for="perteneceComunidadEtnica" class="form-label">Pertenece Comunidad
                                        Étnica</label>
                                    <select v-model="formData.perteneceComunidadEtnica" id="perteneceComunidadEtnica"
                                        class="form-control" required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option value="SI">SI</option>
                                        <option value="NO">NO</option>
                                    </select>
                                </div>

                                <!-- Tipo de Poblaciones Étnicas -->
                                <div class="col-xl-6 mb-3" v-if="formData.perteneceComunidadEtnica === 'SI'">
                                    <label for="tipoPoblacionEtnica" class="form-label">Tipo de Poblaciones
                                        Étnicas</label>
                                    <select v-model="formData.tipoPoblacionEtnica" id="tipoPoblacionEtnica"
                                        class="form-control" required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="tipo in tipoPoblacionesEtnicas" :key="tipo.codigo"
                                            :value="tipo.codigo">
                                            {{ tipo.descripcion }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Tipo de Identificación Otorgante -->
                                <div class="col-xl-6 mb-3">
                                    <label for="tipoIdentificacionOtorgante" class="form-label">Tipo de Identificación
                                        Otorgante</label>
                                    <select v-model="formData.tipoIdentificacionOtorgante"
                                        id="tipoIdentificacionOtorgante" class="form-control" required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="tipo in tipoIdentificaciones" :key="tipo.codigo"
                                            :value="tipo.codigo">
                                            {{ tipo.descripcion }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Número de Identificación del Otorgante-->
                                <div class="col-xl-6 mb-3">
                                    <label for="numeroIdentificacionOtorgante" class="form-label">Número de
                                        Identificación
                                        Otorgante</label>
                                    <input v-model="formData.numeroIdentificacionOtorgante" type="number"
                                        id="numeroIdentificacionOtorgante" class="form-control" required />
                                </div>

                                <!-- Nombres del Otorgante -->
                                <div class="col-xl-6 mb-3">
                                    <label for="nombresApellidosOtorgante" class="form-label">Nombres y Apellidos
                                        Otorgante</label>
                                    <input v-model="formData.nombresApellidosOtorgante" type="text"
                                        id="nombresApellidosOtorgante" class="form-control" required />
                                </div>

                                <!-- Número de Teléfono Otorgante -->
                                <div class="col-xl-6 mb-3">
                                    <label for="numeroTelefonicoOtorgante" class="form-label">Número de Teléfono
                                        Otorgante</label>
                                    <input v-model="formData.numeroTelefonicoOtorgante" type="number"
                                        id="numeroTelefonicoOtorgante" class="form-control" required />
                                </div>

                                <!-- Correo Otorgante -->
                                <div class="col-xl-6 mb-3">
                                    <label for="correoElectronicoOtorgante" class="form-label">Correo del
                                        Otorgante</label>
                                    <input v-model="formData.correoElectronicoOtorgante" type="email"
                                        id="correoElectronicoOtorgante" class="form-control" required />
                                </div>

                                <!-- Dirección Otorgante -->
                                <div class="col-xl-6 mb-3">
                                    <label for="direccionFisicaOtorgante" class="form-label">Dirección del
                                        Otorgante</label>
                                    <input v-model="formData.direccionFisicaOtorgante" type="text"
                                        id="direccionFisicaOtorgante" class="form-control" required />
                                </div>

                                <!-- Sexo Otorgante -->
                                <div class="col-xl-6 mb-3">
                                    <label for="sexoOtorgante" class="form-label">Sexo Del Otorgante</label>
                                    <select v-model="formData.sexoOtorgante" id="sexoOtorgante" class="form-control"
                                        required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="tipo in tipoSexos" :key="tipo.codigo" :value="tipo.codigo">
                                            {{ tipo.descripcion }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Género Otorgante -->
                                <div class="col-xl-6 mb-3">
                                    <label for="generoOtorgante" class="form-label">Género Otorgante</label>
                                    <select v-model="formData.generoOtorgante" id="generoOtorgante" class="form-control"
                                        required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="tipo in tipoGeneros" :key="tipo.codigo" :value="tipo.codigo">
                                            {{ tipo.descripcion }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Tipo Parentesco (Calidad Actua) -->
                                <div class="col-xl-6 mb-3">
                                    <label for="calidadActua" class="form-label">Parentesco Otorgante (Calidad
                                        Actua)</label>
                                    <select v-model="formData.calidadActua" id="calidadActua" class="form-control"
                                        required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="tipo in tipoParentescos" :key="tipo.codigo" :value="tipo.codigo">
                                            {{ tipo.descripcion }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Tipo de Identificación Autorizado Viajar -->
                                <div class="col-xl-6 mb-3">
                                    <label for="tipoIdentificacionAutorizadoViajar" class="form-label">Tipo de
                                        Identificación
                                        Autorizado Viajar</label>
                                    <select v-model="formData.tipoIdentificacionAutorizadoViajar"
                                        id="tipoIdentificacionAutorizadoViajar" class="form-control" required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="tipo in tipoIdentificaciones" :key="tipo.codigo"
                                            :value="tipo.codigo">
                                            {{ tipo.descripcion }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Número de Identificación del Autorizado Viajar-->
                                <div class="col-xl-6 mb-3">
                                    <label for="numeroIdentificacionAutorizadoViajar" class="form-label">Número de
                                        Identificación Autorizado a Viajar</label>
                                    <input v-model="formData.numeroIdentificacionAutorizadoViajar" type="number"
                                        id="numeroIdentificacionAutorizadoViajar" class="form-control" required />
                                </div>

                                <!-- Nombres del Autorizado Viajar -->
                                <div class="col-xl-6 mb-3">
                                    <label for="nombresApellidosAutorizadoViajar" class="form-label">Nombres y Apellidos
                                        Autorizado a Viajar</label>
                                    <input v-model="formData.nombresApellidosAutorizadoViajar" type="text"
                                        id="nombresApellidosAutorizadoViajar" class="form-control" required />
                                </div>

                                <!-- Número de Teléfono Autorizado Viajar -->
                                <div class="col-xl-6 mb-3">
                                    <label for="numeroTelefonicoAutorizadoViajar" class="form-label">Número de Teléfono
                                        Autorizado a Viajar</label>
                                    <input v-model="formData.numeroTelefonicoAutorizadoViajar" type="number"
                                        id="numeroTelefonicoAutorizadoViajar" class="form-control" required />
                                </div>

                                <!-- Dirección Autorizado Viajar -->
                                <div class="col-xl-6 mb-3">
                                    <label for="direccionFisicaAutorizadoViajar" class="form-label">Dirección del
                                        Autorizado
                                        a
                                        Viajar</label>
                                    <input v-model="formData.direccionFisicaAutorizadoViajar" type="text"
                                        id="direccionFisicaAutorizadoViajar" class="form-control" required />
                                </div>
                                <!-- Tipo de Identificación Autorizado Recoger -->
                                <div class="col-xl-6 mb-3">
                                    <label for="tipoIdentificacionAutorizadoRecoger" class="form-label">Tipo de
                                        Identificación
                                        Autorizado Recoger</label>
                                    <select v-model="formData.tipoIdentificacionAutorizadoRecoger"
                                        id="tipoIdentificacionAutorizadoRecoger" class="form-control" required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="tipo in tipoIdentificaciones" :key="tipo.codigo"
                                            :value="tipo.codigo">
                                            {{ tipo.descripcion }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Número de Identificación del Autorizado Recoger-->
                                <div class="col-xl-6 mb-3">
                                    <label for="numeroIdentificacionAutorizadoRecoger" class="form-label">Número de
                                        Identificación Autorizado a Recoger</label>
                                    <input v-model="formData.numeroIdentificacionAutorizadoRecoger" type="number"
                                        id="numeroIdentificacionAutorizadoRecoger" class="form-control" required />
                                </div>

                                <!-- Nombres del Autorizado Recoger -->
                                <div class="col-xl-6 mb-3">
                                    <label for="nombresApellidosAutorizadoRecoger" class="form-label">Nombres y
                                        Apellidos
                                        Autorizado a Recoger</label>
                                    <input v-model="formData.nombresApellidosAutorizadoRecoger" type="text"
                                        id="nombresApellidosAutorizadoRecoger" class="form-control" required />
                                </div>

                                <!-- Número de Teléfono Autorizado Recoger -->
                                <div class="col-xl-6 mb-3">
                                    <label for="numeroTelefonicoAutorizadoRecoger" class="form-label">Número de Teléfono
                                        Autorizado a Recoger</label>
                                    <input v-model="formData.numeroTelefonicoAutorizadoRecoger" type="number"
                                        id="numeroTelefonicoAutorizadoRecoger" class="form-control" required />
                                </div>

                                <!-- Dirección Autorizado Recoger -->
                                <div class="col-xl-6 mb-3">
                                    <label for="direccionFisicaAutorizadoRecoger" class="form-label">Dirección del
                                        Autorizado a
                                        Recoger</label>
                                    <input v-model="formData.direccionFisicaAutorizadoRecoger" type="text"
                                        id="direccionFisicaAutorizadoRecoger" class="form-control" required />
                                </div>

                            </div>
                        </PasoAPaso>
                        <PasoAPaso numero="2" descripcion="Paso 2, Adjuntar archivos (obligatorio)" class="w-100 mt-4">
                            <h4 class="py-2 border-collapse font-weight-bold">Subir copia Autorización Viaje</h4>
                            <DropFileBasic ref="dropFileAutorizacion"
                                @handleFileData="(file) => handleArchivoGeneral({ file, campo: 'copiaAutorizacionViaje', nombreCampo: 'Copia Autorización de Viaje' })"
                                :fileTypes="['application/pdf']" />

                            <h4 class="py-2 border-collapse font-weight-bold">Subir Copia Parentesco</h4>
                            <DropFileBasic ref="dropFileParentesco"
                                @handleFileData="(file) => handleArchivoGeneral({ file, campo: 'copiaDocumentoParentesco', nombreCampo: 'Documento de Parentesco' })"
                                :fileTypes="['application/pdf']" />

                            <h4 class="py-2 border-collapse font-weight-bold">Subir Copia Documento identidad autorizado
                            </h4>
                            <DropFileBasic ref="dropFileIdentidad"
                                @handleFileData="(file) => handleArchivoGeneral({ file, campo: 'copiaDocumentoIdentidadAutorizado', nombreCampo: 'Documento de Identidad del Autorizado' })"
                                :fileTypes="['application/pdf']" />

                            <h4 class="py-2 border-collapse font-weight-bold">Subir Copia Constancia Entrega</h4>
                            <DropFileBasic ref="dropFileConstancia"
                                @handleFileData="(file) => handleArchivoGeneral({ file, campo: 'copiaConstanciaEntrega', nombreCampo: 'Constancia de Entrega' })"
                                :fileTypes="['application/pdf']" />
                        </PasoAPaso>
                        <!-- Botón de Depuración -->
                        <div class="d-flex justify-content-end mt-4 mb-3">
                            <button type="button" class="btn btn-info mr-2" @click="debugFormData">
                                Depurar Datos
                            </button>
                        </div>

                        <!-- Botón Guardar -->
                        <div class="d-flex justify-content-end mt-2">
                            <vs-button type="submit" animation-type="vertical" :loading="isLoading">
                                Guardar Registro
                                <template #animate>
                                    <i class="fas fa-plus-circle"></i>
                                </template>
                            </vs-button>
                        </div>
                    </form>
                </div>
                <!-- Mostrar estado del registro -->
                <div v-if="registrationStatus !== 'pending'" class="alert mt-3" :class="statusClass">
                    <i class="fas" :class="statusIcon"></i>
                    {{ statusMessage }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DropFileBasic from "@/components/helexium/DropFileBasic.vue";
import PasoAPaso from './PasoAPaso.vue';

export default {
    components: {
        DropFileBasic,
        PasoAPaso
    },
    props: {
        infoComplementaria: {
            type: Object,
            required: true
        },
        idMantenimiento: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            tipoIdentificaciones: [],
            selectedTipoIdentificacion: "",
            CentrosPoblados: [],
            selectedCentrosPoblados: "",
            tipoDiscapacidades: [],
            selectedTipoDiscapacidades: "",
            tipoPoblacionesEtnicas: [],
            selectedTipoPoblacionesEtnicas: "",
            tipoGeneros: [],
            selectedTipoGeneros: "",
            tipoSexos: [],
            selectedTipoSexos: "",
            tipoParentescos: [],
            selectedTipoParentescos: "",
            selectedPlacasObtenidas: "",


            formData: {
                fechaViaje: null,
                origen: "",
                destino: "",

                // Datos del NNa
                tipoIdentificacionNna: null,
                numeroIdentificacionNna: null,
                nombresApellidosNna: null,
                situacionDiscapacidad: "NO",
                tipoDiscapacidad: 7,
                perteneceComunidadEtnica: "NO",
                tipoPoblacionEtnica: 6,
                // Datos del otorgante
                tipoIdentificacionOtorgante: null,
                numeroIdentificacionOtorgante: null,
                nombresApellidosOtorgante: null,
                numeroTelefonicoOtorgante: null,
                correoElectronicoOtorgante: null,
                direccionFisicaOtorgante: null,
                sexoOtorgante: null,
                generoOtorgante: null,
                calidadActua: null,
                // Datos del autorizado a viajar
                tipoIdentificacionAutorizadoViajar: null,
                numeroIdentificacionAutorizadoViajar: null,
                nombresApellidosAutorizadoViajar: null,
                numeroTelefonicoAutorizadoViajar: null,
                direccionFisicaAutorizadoViajar: null,
                // Datos del autorizado a recoger
                tipoIdentificacionAutorizadoRecoger: null,
                numeroIdentificacionAutorizadoRecoger: null,
                nombresApellidosAutorizadoRecoger: null,
                numeroTelefonicoAutorizadoRecoger: null,
                direccionFisicaAutorizadoRecoger: null,
                // Documentos
                copiaAutorizacionViajeNombreOriginal: null,
                copiaAutorizacionViajeDocumento: null,
                copiaAutorizacionViajeRuta: null,
                copiaDocumentoParentescoNombreOriginal: null,
                copiaDocumentoParentescoDocumento: null,
                copiaDocumentoParentescoRuta: null,
                copiaDocumentoIdentidadAutorizadoNombreOriginal: null,
                copiaDocumentoIdentidadAutorizadoDocumento: null,
                copiaDocumentoIdentidadAutorizadoRuta: null,
                copiaConstanciaEntregaNombreOriginal: null,
                copiaConstanciaEntregaDocumento: null,
                copiaConstanciaEntregaRuta: null,

            },
            isLoading: false,
            registrationStatus: 'pending', // pending, registered, error
            errorMessage: '',
        }
    },
    computed: {
        ...mapGetters(['useMoment']),
        statusClass() {
            return {
                'alert-success': this.registrationStatus === 'registered',
                'alert-danger': this.registrationStatus === 'error'
            }
        },
        statusIcon() {
            return {
                'fa-check-circle': this.registrationStatus === 'registered',
                'fa-exclamation-circle': this.registrationStatus === 'error'
            }
        },
        statusMessage() {
            if (this.registrationStatus === 'registered') {
                return `Autorización registrada exitosamente con ID: ${this.mantenimientoId}`;
            } else if (this.registrationStatus === 'error') {
                return `Error: ${this.errorMessage}`;
            }
            return '';
        },

    },
    async mounted() {
        await this.obtenerTiposIdentificacion();
        await this.obtenerCentrosPoblados();
        await this.obtenerTipoDiscapacidades();
        await this.obtenerTipoPoblacionesEtnicas();
        await this.obtenerTipoGeneros();
        await this.obtenerTipoSexos();
        await this.obtenerTipoParentescos();

    },
    methods: {
        // Método para depurar los datos del formulario
        debugFormData() {
            console.log("==== DEBUG FORM DATA ====");
            console.log(JSON.stringify(this.formData, null, 2));

            // Verificar campos faltantes
            const camposFaltantes = [];
            const camposObligatorios = [
                "fechaViaje",
                "origen",
                "destino",
                "tipoIdentificacionNna",
                "numeroIdentificacionNna",
                "nombresApellidosNna",
                "tipoIdentificacionOtorgante",
                "numeroIdentificacionOtorgante",
                "nombresApellidosOtorgante",
                "numeroTelefonicoOtorgante",
                "correoElectronicoOtorgante",
                "direccionFisicaOtorgante",
                "sexoOtorgante",
                "generoOtorgante",
                "calidadActua",
                "tipoIdentificacionAutorizadoViajar",
                "numeroIdentificacionAutorizadoViajar",
                "nombresApellidosAutorizadoViajar",
                "tipoIdentificacionAutorizadoRecoger",
                "numeroIdentificacionAutorizadoRecoger",
                "nombresApellidosAutorizadoRecoger",
            ];

            for (const campo of camposObligatorios) {
                if (!this.formData[campo]) {
                    camposFaltantes.push(campo);
                }
            }

            console.log("CAMPOS FALTANTES:", camposFaltantes.length > 0 ? camposFaltantes : "Ninguno");

            // Verificar documentos
            const documentosFaltantes = [];
            if (!this.formData.copiaAutorizacionViajeDocumento) documentosFaltantes.push("Autorización de viaje");
            if (!this.formData.copiaDocumentoParentescoDocumento) documentosFaltantes.push("Documento de parentesco");
            if (!this.formData.copiaDocumentoIdentidadAutorizadoDocumento)
                documentosFaltantes.push("Documento de identidad autorizado");
            if (!this.formData.copiaConstanciaEntregaDocumento) documentosFaltantes.push("Constancia de entrega");

            console.log("DOCUMENTOS FALTANTES:", documentosFaltantes.length > 0 ? documentosFaltantes : "Ninguno");
            console.log("==== FIN DEBUG ====");

            // Mostrar alerta con resumen
            if (camposFaltantes.length > 0 || documentosFaltantes.length > 0) {
                let mensaje = "";
                if (camposFaltantes.length > 0) {
                    mensaje += `Campos faltantes: ${camposFaltantes.join(", ")}\n`;
                }
                if (documentosFaltantes.length > 0) {
                    mensaje += `Documentos faltantes: ${documentosFaltantes.join(", ")}`;
                }

                this.$vs.notification({
                    color: "warning",
                    title: "Datos incompletos",
                    text: mensaje,
                });
            } else {
                this.$vs.notification({
                    color: "success",
                    title: "Datos completos",
                    text: "Todos los campos obligatorios están completos",
                });
            }
        },

        async handleArchivoGeneral({ file, campo, nombreCampo, idVigilado = this.infoComplementaria.vigiladoId, tipoMantenimiento = this.infoComplementaria.tipoId }) {
            if (!file) return;

            if (file.type !== 'application/pdf') {
                this.mostrarNotificacion('error', 'Archivo inválido', 'Solo se permiten archivos PDF.');
                return;
            }

            try {
                const resultado = await this.$store.dispatch('hl_post_file_cookie', {
                    path: `ApiSuperTransporteMantenimientos/subir-archivo?idVigilado=${idVigilado}&tipoMantenimiento=${tipoMantenimiento}&soloSubir=true`,
                    data: file
                })

                if (resultado) {
                    // Actualiza los campos de formData dinámicamente
                    this.$set(this.formData, `${campo}NombreOriginal`, resultado.nombreOriginalArchivo);
                    this.$set(this.formData, `${campo}Documento`, resultado.nombreAlmacenado);
                    this.$set(this.formData, `${campo}Ruta`, resultado.ruta);

                    console.log(`Archivo ${nombreCampo} cargado:`, resultado);

                    this.$vs.notification({
                        progress: "auto",
                        icon: `<i class='fas fa-check-circle'></i>`,
                        color: "success",
                        position: "top-right",
                        title: "Éxito",
                        text: `${nombreCampo} cargado correctamente`,
                    });
                }
            } catch (error) {
                console.error(`Error al subir ${nombreCampo}:`, error);
                this.$vs.notification({
                    color: "danger",
                    title: "Error",
                    text: `No se pudo cargar ${nombreCampo}`,
                });
            }
        },


        // Método para guardar la autorización con depuración mejorada
        async guardarAutorizacion() {
            try {
                this.isLoading = true;
                this.registrationStatus = 'pending';


                this.formData = {
                    ...this.formData,
                    mantenimientoId: this.idMantenimiento,
                }

                // AÑADIR AQUÍ - Ver todos los datos que se enviarán
                console.log("DATOS A ENVIAR:", JSON.stringify(this.formData, null, 2));


                // Validar que todos los campos requeridos estén completos
                if (!this.validarFormulario()) {
                    this.isLoading = false;
                    return;
                }

                // Llamar al método para registrar la autorización
                const resultado = await this.$store.dispatch('hl_post_cookie', {
                    path: `ApiSuperTransporteMantenimientos/registrar-autorizacion`,
                    data: this.formData
                })

                if (resultado) {
                    // AÑADIR AQUÍ - Ver la respuesta de la API
                    console.log("RESPUESTA DE LA API:", resultado);

                    this.formData.mantenimientoId = resultado.id || resultado.mantenimientoId;
                    this.registrationStatus = 'registered';
                    this.$emit('consultarMantenimientos')
                    // Mostrar notificación de éxito
                    this.$vs.notification({
                        progress: "auto",
                        icon: `<i class='fas fa-check-circle'></i>`,
                        color: "success",
                        position: "top-right",
                        title: "Éxito",
                        text: "Autorización registrada correctamente",
                    });
                }
            } catch (error) {
                console.error("Error al guardar autorización:", error);
                this.registrationStatus = 'error';
                this.errorMessage = error.message || "Error al guardar la autorización";

                this.$vs.notification({
                    color: "danger",
                    title: "Error",
                    text: this.errorMessage
                });
            } finally {
                this.isLoading = false;
            }
        },

        // Método para validar el formulario con mejor depuración
        validarFormulario() {
            // Validar campos obligatorios
            const camposObligatorios = [
                "fechaViaje",
                "origen",
                "destino",
                "tipoIdentificacionNna",
                "numeroIdentificacionNna",
                "nombresApellidosNna",
                "tipoIdentificacionOtorgante",
                "numeroIdentificacionOtorgante",
                "nombresApellidosOtorgante",
                "numeroTelefonicoOtorgante",
                "correoElectronicoOtorgante",
                "direccionFisicaOtorgante",
                "sexoOtorgante",
                "generoOtorgante",
                "calidadActua",
                "tipoIdentificacionAutorizadoViajar",
                "numeroIdentificacionAutorizadoViajar",
                "nombresApellidosAutorizadoViajar",
                "tipoIdentificacionAutorizadoRecoger",
                "numeroIdentificacionAutorizadoRecoger",
                "nombresApellidosAutorizadoRecoger",
            ];

            const camposFaltantes = [];

            for (const campo of camposObligatorios) {
                if (!this.formData[campo]) {
                    camposFaltantes.push(campo);
                }
            }

            // Mostrar en consola los campos faltantes
            if (camposFaltantes.length > 0) {
                console.log("CAMPOS FALTANTES:", camposFaltantes);
                this.$vs.notification({
                    color: "warning",
                    title: "Campos incompletos",
                    text: `Faltan los siguientes campos: ${camposFaltantes.join(", ")}`,
                });
                return false;
            }

            // Validar campos condicionales
            if (this.formData.situacionDiscapacidad === "SI" && !this.formData.tipoDiscapacidad) {
                console.log("FALTA TIPO DE DISCAPACIDAD");
                this.$vs.notification({
                    color: "warning",
                    title: "Campos incompletos",
                    text: "Debe seleccionar un tipo de discapacidad",
                });
                return false;
            }

            if (this.formData.perteneceComunidadEtnica === "SI" && !this.formData.tipoPoblacionEtnica) {
                console.log("FALTA TIPO DE POBLACIÓN ÉTNICA");
                this.$vs.notification({
                    color: "warning",
                    title: "Campos incompletos",
                    text: "Debe seleccionar un tipo de población étnica",
                });
                return false;
            }

            // Validar que se hayan cargado los documentos
            const documentosFaltantes = [];
            if (!this.formData.copiaAutorizacionViajeDocumento) documentosFaltantes.push("Autorización de viaje");
            if (!this.formData.copiaDocumentoParentescoDocumento) documentosFaltantes.push("Documento de parentesco");

            if (documentosFaltantes.length > 0) {
                console.log("DOCUMENTOS FALTANTES:", documentosFaltantes);
                this.$vs.notification({
                    color: "warning",
                    title: "Documentos incompletos",
                    text: `Debe cargar los siguientes documentos: ${documentosFaltantes.join(", ")}`,
                });
                return false;
            }

            console.log("VALIDACIÓN EXITOSA: Todos los campos requeridos están completos");
            return true;
        },


        async obtenerTiposIdentificacion() {
            try {
                // Mostrar indicador de carga
                this.isLoading = true;

                // Llamar al servicio para obtener los tipos de identificación
                const response = await this.$store.dispatch("hl_get_cookie", {
                    path: "ApiSuperTransporteGenerales/listar-tipo-identificaciones",
                });

                console.log("Tipos de identificación recibidos:", response);

                // CORRECCIÓN: La respuesta ya es JSON, no necesitamos llamar a .json() nuevamente
                if (Array.isArray(response)) {
                    // Filtrar solo los tipos activos
                    this.tipoIdentificaciones = response.filter(item => item.estado === true);
                    console.log("Tipos de identificación filtrados:", this.tipoIdentificaciones);
                } else {
                    console.warn("El formato de la respuesta no es un array:", response);
                    this.$vs.notification({
                        color: "warning",
                        title: "Advertencia",
                        text: "El formato de los datos recibidos no es el esperado"
                    });
                }
            } catch (error) {
                console.error("Error al obtener tipos de identificación:", error);
                this.$vs.notification({
                    color: "danger",
                    title: "Error de conexión",
                    text: "Hubo un problema al conectar con el servidor"
                });
            } finally {
                // Ocultar indicador de carga
                this.isLoading = false;
            }
        },
        async obtenerCentrosPoblados() {
            try {
                // Mostrar indicador de carga
                this.isLoading = true;

                // Llamar al servicio para obtener los Centors poblados
                const response = await this.$store.dispatch("hl_get_cookie", {
                    path: "ApiSuperTransporteGenerales/listar-centros-poblados",
                });

                // CORRECCIÓN: La respuesta ya es JSON, no necesitamos llamar a .json() nuevamente
                if (Array.isArray(response)) {
                    // Filtrar solo los tipos activos
                    this.CentrosPoblados = response.filter(item => item.estado === true);
                    console.log("Centros Poblados filtrados:", this.CentrosPoblados);
                } else {
                    console.warn("El formato de la respuesta no es un array:", response);
                    this.$vs.notification({
                        color: "warning",
                        title: "Advertencia",
                        text: "El formato de los datos recibidos no es el esperado"
                    });
                }
            } catch (error) {
                console.error("Error al obtener los Centros Poblados:", error);
                this.$vs.notification({
                    color: "danger",
                    title: "Error de conexión",
                    text: "Hubo un problema al conectar con el servidor"
                });
            } finally {
                // Ocultar indicador de carga
                this.isLoading = false;
            }
        },
        async obtenerTipoDiscapacidades() {
            try {
                // Mostrar indicador de carga
                this.isLoading = true;

                // Llamar al servicio para obtener los tipos de Discapacidades
                const response = await this.$store.dispatch("hl_get_cookie", {
                    path: "ApiSuperTransporteGenerales/listar-tipo-discapacidades",
                });

                console.log("Tipos de Discapacidades recibidos:", response);

                // CORRECCIÓN: La respuesta ya es JSON, no necesitamos llamar a .json() nuevamente
                if (Array.isArray(response)) {
                    // Filtrar solo los tipos activos
                    this.tipoDiscapacidades = response.filter(item => item.estado === true);
                    console.log("tipos de Discapacidades filtrados:", this.tipoDiscapacidades);
                } else {
                    console.warn("El formato de la respuesta no es un array:", response);
                    this.$vs.notification({
                        color: "warning",
                        title: "Advertencia",
                        text: "El formato de los datos recibidos no es el esperado"
                    });
                }
            } catch (error) {
                console.error("Error al obtener los tipos de Discapacidades:", error);
                this.$vs.notification({
                    color: "danger",
                    title: "Error de conexión",
                    text: "Hubo un problema al conectar con el servidor"
                });
            } finally {
                // Ocultar indicador de carga
                this.isLoading = false;
            }
        },
        async obtenerTipoPoblacionesEtnicas() {
            try {
                // Mostrar indicador de carga
                this.isLoading = true;

                // Llamar al servicio para obtener los tipos de Poblaciones Etnicas
                const response = await this.$store.dispatch("hl_get_cookie", {
                    path: "ApiSuperTransporteGenerales/listar-tipo-poblaciones-etnicas",
                });

                console.log("tipos de Poblaciones Etnicas recibidos:", response);

                // CORRECCIÓN: La respuesta ya es JSON, no necesitamos llamar a .json() nuevamente
                if (Array.isArray(response)) {
                    // Filtrar solo los tipos activos
                    this.tipoPoblacionesEtnicas = response.filter(item => item.estado === true);
                    console.log("Tipos de Poblaciones Etnicas filtrados:", this.tipoPoblacionesEtnicas);
                } else {
                    console.warn("El formato de la respuesta no es un array:", response);
                    this.$vs.notification({
                        color: "warning",
                        title: "Advertencia",
                        text: "El formato de los datos recibidos no es el esperado"
                    });
                }
            } catch (error) {
                console.error("Error al obtener tipos de Poblaciones Etnicasn:", error);
                this.$vs.notification({
                    color: "danger",
                    title: "Error de conexión",
                    text: "Hubo un problema al conectar con el servidor"
                });
            } finally {
                // Ocultar indicador de carga
                this.isLoading = false;
            }
        },
        async obtenerTipoGeneros() {
            try {
                // Mostrar indicador de carga
                this.isLoading = true;

                // Llamar al servicio para obtener los tipos de Generos
                const response = await this.$store.dispatch("hl_get_cookie", {
                    path: "ApiSuperTransporteGenerales/listar-tipo-generos",
                });

                console.log("Tipos de Generos recibidos:", response);

                // CORRECCIÓN: La respuesta ya es JSON, no necesitamos llamar a .json() nuevamente
                if (Array.isArray(response)) {
                    // Filtrar solo los tipos activos
                    this.tipoGeneros = response.filter(item => item.estado === true);
                    console.log("Tipos de Generos filtrados:", this.tipoGeneros);
                } else {
                    console.warn("El formato de la respuesta no es un array:", response);
                    this.$vs.notification({
                        color: "warning",
                        title: "Advertencia",
                        text: "El formato de los datos recibidos no es el esperado"
                    });
                }
            } catch (error) {
                console.error("Error al obtener Tipos de Generos:", error);
                this.$vs.notification({
                    color: "danger",
                    title: "Error de conexión",
                    text: "Hubo un problema al conectar con el servidor"
                });
            } finally {
                // Ocultar indicador de carga
                this.isLoading = false;
            }
        },
        async obtenerTipoSexos() {
            try {
                // Mostrar indicador de carga
                this.isLoading = true;

                // Llamar al servicio para obtener los tipos de Sexos
                const response = await this.$store.dispatch("hl_get_cookie", {
                    path: "ApiSuperTransporteGenerales/listar-tipo-sexos",
                });

                console.log("Tipos de Sexos recibidos:", response);

                // CORRECCIÓN: La respuesta ya es JSON, no necesitamos llamar a .json() nuevamente
                if (Array.isArray(response)) {
                    // Filtrar solo los tipos activos
                    this.tipoSexos = response.filter(item => item.estado === true);
                    console.log("Tipos de Sexos filtrados:", this.tipoSexos);
                } else {
                    console.warn("El formato de la respuesta no es un array:", response);
                    this.$vs.notification({
                        color: "warning",
                        title: "Advertencia",
                        text: "El formato de los datos recibidos no es el esperado"
                    });
                }
            } catch (error) {
                console.error("Error al obtener Tipos de Sexos:", error);
                this.$vs.notification({
                    color: "danger",
                    title: "Error de conexión",
                    text: "Hubo un problema al conectar con el servidor"
                });
            } finally {
                // Ocultar indicador de carga
                this.isLoading = false;
            }
        },
        async obtenerTipoParentescos() {
            try {
                // Mostrar indicador de carga
                this.isLoading = true;

                // Llamar al servicio para obtener los tipos de Parentescos
                const response = await this.$store.dispatch("hl_get_cookie", {
                    path: "ApiSuperTransporteGenerales/listar-tipo-parentescos",
                });

                console.log("Tipos de Parentescos recibidos:", response);

                // CORRECCIÓN: La respuesta ya es JSON, no necesitamos llamar a .json() nuevamente
                if (Array.isArray(response)) {
                    // Filtrar solo los tipos activos
                    this.tipoParentescos = response.filter(item => item.estado === true);
                    console.log("Tipos de Parentescos filtrados:", this.tipoParentescos);
                } else {
                    console.warn("El formato de la respuesta no es un array:", response);
                    this.$vs.notification({
                        color: "warning",
                        title: "Advertencia",
                        text: "El formato de los datos recibidos no es el esperado"
                    });
                }
            } catch (error) {
                console.error("Error al obtener tipos de Parentescos:", error);
                this.$vs.notification({
                    color: "danger",
                    title: "Error de conexión",
                    text: "Hubo un problema al conectar con el servidor"
                });
            } finally {
                // Ocultar indicador de carga
                this.isLoading = false;
            }
        },
        // Método para mostrar notificaciones
        mostrarNotificacion(tipo, titulo, mensaje) {
            this.$vs.notification({
                progress: "auto",
                color: tipo,
                position: "top-right",
                title: titulo,
                text: mensaje
            });
        }
    }
};
</script>

<style scoped>
.border-collapse {
    border-bottom: .5px solid #dee2e6;
    cursor: pointer;
}
</style>
